import React from "react";
import { Link } from "react-router-dom";
import { LANDING } from "@/constants/testIds";

/**
 * Brand mark — KR monogram (cream-recoloured) + wordmark + small
 * tagline. Tagline can be hidden via `showTagline={false}`.
 */
const Logo = ({
  size = "default",
  testId = LANDING.logo,
  showTagline = true,
}) => {
  const isSmall = size === "small";
  return (
    <Link
      to="/"
      data-testid={testId}
      className="flex items-center gap-4 group"
      aria-label="Kellermann Reid & Co. — Home"
    >
      <img
        src="/brand/kr-monogram-cream.png"
        alt=""
        aria-hidden="true"
        className={`${
          isSmall ? "h-7" : "h-[34px]"
        } w-auto object-contain transition-transform duration-700 group-hover:-rotate-1`}
        loading="eager"
        decoding="async"
      />
      <span className="leading-tight">
        <span
          className={`block font-serif-display text-[var(--kr-text)] tracking-tight ${
            isSmall ? "text-[17px]" : "text-[19px]"
          }`}
        >
          Kellermann Reid{" "}
          <span className="text-[var(--kr-gold)] italic">&amp;</span> Co.
        </span>
        {showTagline ? (
          <span
            className={`block font-mono-label text-[var(--kr-text-muted)] mt-[3px] ${
              isSmall ? "text-[7.5px]" : "text-[8px]"
            }`}
            style={{ letterSpacing: "0.32em" }}
          >
            Private Markets Investment House
          </span>
        ) : null}
      </span>
    </Link>
  );
};

export default Logo;
